<template>
  <modal
    :name="name"
    :scrollable="true"
    height="auto"
    adaptive
  >
    <div>
      <header class="w-full py-5 md:border-b md:border-sc-gray-light">
        <div class="flex justify-between px-5 text-xl text-left text-sc-gray-dark">
          <p>
            {{ title }}
          </p>
          <button
            @click="hide()"
          >
            <img
              :src="require('@assets/images/cross.svg')"
              class="self-center h-5 p-1 ml-1"
              alt="cerrar"
            >
          </button>
        </div>
      </header>
      <div class="flex flex-col md:p-5 text-center md:border-b md:border-sc-gray-light content">
        <p class="text-sm text-sc-gray">
          {{ content }}
        </p>
        <b-input
          v-if="isApprovalModal"
          type="textarea"
          placeholder="Escribe un comentario"
          class="bottom-0 mt-5"
          v-model="newComment"
        />
      </div>
      <div class="flex w-full pb-5 px-5 md:pt-5">
        <button
          class="inline-block w-full py-3 mr-2 text-sm leading-5 text-center rounded focus:outline-none shadow-sc-button"
          :class="flipButtonsStyle ? 'text-white bg-sc-blue hover:bg-sc-blue-light' : 'text-primary hover:opacity-75'"
          @click="onConfirmation()"
        >
          {{ confirmationButtonText }}
        </button>
        <button
          class="inline-block w-full py-3 ml-2 text-sm leading-5 text-center rounded text-primary focus:outline-none hover:opacity-75 shadow-sc-button"
          :class="flipButtonsStyle ? 'text-primary hover:opacity-75' : 'text-white bg-sc-blue hover:bg-sc-blue-light'"
          @click="hide()"
        >
          {{ cancelButtonText }}
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  data() {
    return {
      active: this.isModalActive,
      newComment: '',
    };
  },
  props: {
    isModalActive: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: 'confirmation-modal',
    },
    title: {
      type: String,
      default: 'Confirmación',
    },
    content: {
      type: String,
      required: true,
    },
    confirmationButtonText: {
      type: String,
      default: 'Confirmar',
    },
    cancelButtonText: {
      type: String,
      default: 'Cancelar',
    },
    flipButtonsStyle: {
      type: Boolean,
      default: false,
    },
    isApprovalModal: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    onConfirmation() {
      this.$emit('confirmation', this.newComment);
      this.newComment = '';
      this.hide();
    },
    show() {
      this.$modal.show(this.name);
    },
    hide() {
      this.$modal.hide(this.name);
    },
  },
};
</script>>
